'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function RecalculatingState() {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    blockSize: "100%",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.revenueAttributionCard.recalculatingState.title"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "components.revenueAttributionCard.recalculatingState.description"
    })]
  });
}